import { complaintStatusEnum } from "../enumTypes/enums";
import { Farmlink, Gaon, gaonTextBasedOnRoleTYpe } from "../helper/constants";

const role = localStorage.getItem("role");
const handleGaonText = () => {
  if (Farmlink()) {
    return "Villages";
  } else {
    return "Gaons";
  }
};

export const sidenavData = [
  {
    title: "Dashboard",
    icon: "dashboard",
    path: "/",
  },
  {
    title: "Buyer Request",
    icon: "home",
    path: "/buyerReqest/list",
  },
];

export const warehouse = [
  {
    title: "Dashboard",
    icon: "dashboard",
    path: "/",
  },
  {
    title: "Buyer request",
    // path: "/bidWarehouse",
    icon: "warehouse",
    submenu: [
      {
        title: "New Requests",
        path: "/bidWarehouse/new-requests",
        icon: "warehouse",
      },
      {
        title: "Applied Requests",
        path: "/bidWarehouse/applied-requests",
        icon: "warehouse",
      },
      {
        title: "Confirmed Requests",
        path: "/bidWarehouse/confirmed-requests",
        icon: "warehouse",
      },
      {
        title: "Completed Requests",
        // path: "/bidWarehouse/completed-requests",
        icon: "warehouse",
        submenu: [
          {
            title: "New Requests",
            path: "/bidWarehouse/new-requests",
            icon: "warehouse",
          },
          {
            title: "Applied Requests",
            path: "/bidWarehouse/applied-requests",
            icon: "warehouse",
          },
          {
            title: "Confirmed Requests",
            path: "/bidWarehouse/confirmed-requests",
            icon: "warehouse",
          },
          {
            title: "Completed Requests",
            path: "/bidWarehouse/completed-requests",
            icon: "warehouse",
          },
        ],
      },
    ],
  },
  {
    title: "Your request to the farmers",
    path: "/warehouseRequest/list",
    icon: "farm",
  },
  {
    title: "Available products nearby",
    // path: "/farmer/products",
    icon: "farmer_product",
    submenu: [
      {
        title: "New Requests",
        path: "/farmer-products/new-requests",
        icon: "warehouse",
      },
      {
        title: "Applied Requests",
        path: "/farmer-products/applied-requests",
        icon: "warehouse",
      },
      {
        title: "Confirmed Requests",
        path: "/farmer-products/confirmed-requests",
        icon: "warehouse",
      },
      {
        title: "Rejected Requests",
        path: "/farmer-products/rejected-requests",
        icon: "warehouse",
      },
      {
        title: "Closed Requests",
        path: "/farmer-products/closed-requests",
        icon: "warehouse",
      },
    ],
  },
];

export const adminMenu = [
  {
    title: "Dashboard",
    icon: "dashboard",
    path: "/",
  },
  {
    // title: gaonTextBasedOnRoleTYpe() + "s",
    title: handleGaonText(),
    path: "/gaon",
    icon: "gaon",
  },
  {
    title: "Users",
    path: "/userList",
    icon: "users",
  },
  {
    title: "Units",
    path: "/unitList",
    icon: "units",
  },
  {
    title: "Products",
    path: "/product/list",
    icon: "products",
  },
  {
    title: "Minimum Selling Price",
    path: "/msp/list",
    icon: "priceTag",
  },

  {
    title: "Grade",
    path: "/grade/list",
    icon: "gradeIcon",
  },
];

export const superAdminMenu = [
  {
    title: "Dashboard",
    icon: "dashboard",
    path: "/",

    // submenu: [
    //   {
    //     title: "Community",
    //     path: "/community",
    //     icon: "warehouse",
    //   },
    //   {
    //     title: "Warehouse Management",
    //     path: "/",
    //     icon: "warehouse",
    //   },
    // ],
  },

  {
    title: handleGaonText(),
    path: "/gaon",
    icon: "gaon",
  },
  {
    title: "Users",
    // path: "/userList",
    icon: "users",
    submenu: [
      {
        title: "Create New User",
        path: "/users/add-new-user",
        icon: "user_control",
      },
      {
        title: "User List",
        path: "/users/userList",
        icon: "user_control",
      },
      {
        title: "User Department",
        path: "/users/userdepartment",
        icon: "user_control",
      },
    ],
  },

  {
    title: "Contest Manager",
    // path: "/module/list",
    icon: "contest",
    submenu: [
      {
        title: "Create Contest",
        path: "/contest/create-new-contest",
        icon: "contest",
      },
      {
        title: "Contest List",
        path: "/contest/contest-list",
        icon: "contest",
      },
      {
        title: "Question Library",
        path: "/contest/question-library",
        icon: "contest",
      },
      {
        title: "Withdrawal",
        path: "/contest/withdrawal",
        icon: "withdrawl",
      },
    ],
  },

  {
    title: "Promotion Tools",
    // path: "/user-notification",
    icon: "users",
    submenu: [
      {
        title: "Notification",
        path: "/user-notification",
        icon: "users",
      },
      {
        title: "Banner",
        path: "/banner/list",
        icon: "Help",
      },
    ],
  },

  {
    title: "Admin Feed Management",
    // path: "/news",
    icon: "news",
    submenu: [
      { title: "News", path: "/admin/news", icon: "news" },
      {
        title: "Calendar Event",
        path: "/admin/calendar-event",
        icon: "calendar",
      },
      {
        title: "Story",
        path: "/admin/story-list",
        icon: "users",
      },
    ],
  },
  {
    title: "Warehouse Management",
    icon: "priceTag",
    submenu: [
      { title: "Minimum Selling Price", path: "/msp/list", icon: "priceTag" },
      {
        title: "Grade",
        path: "/grade/list",
        icon: "gradeIcon",
      },
      {
        title: "Units",
        path: "/unitList",
        icon: "units",
      },
      {
        title: "Products",
        path: "/product/list",
        icon: "products",
      },
    ],
  },

  {
    title: "Govt. Scheme",
    path: "/govt-scheme",
    icon: "users",
  },
  {
    title: "Rural revolution",
    path: "/rural-revolution",
    icon: "users",
  },
  {
    title: "Impact Story",
    path: "/impact-story",
    icon: "users",
  },
  {
    title: "Shorts Video",
    path: "/shorts/list",
    icon: "contest",
  },
];

export const userSidenav = [
  {
    title: "Dashboard",
    icon: "dashboard",
    path: "/",
  },
  {
    title: "Complaints",
    // path: `/complaints/${complaintStatusEnum.PENDING}`,
    icon: "units",
    submenu: [
      {
        title: "Pending",
        path: "/complaints/pending",
        icon: "units",
      },
      {
        title: "In-Progress",
        path: "/complaints/in-progress",
        icon: "units",
      },
      {
        title: "Completed",
        path: "/complaints/completed",
        icon: "units",
      },
      {
        title: "Rejected",
        path: "/complaints/rejected",
        icon: "units",
      },
    ],
  },
];

export const exporterMenu = [
  {
    title: "Dashboard",
    icon: "dashboard",
    path: "/",
  },
  {
    title: "Exporter Request",
    icon: "home",
    path: "/buyerReqest/list",
  },
];

export const retailerMenu = [
  {
    title: "Dashboard",
    icon: "dashboard",
    path: "/",
  },
  {
    title: "Retailer Request",
    icon: "home",
    // path: "/buyerReqest/list",
    submenu: [
      {
        title: "Create New Request",
        path: "/buyerRequest/add",
        icon: "warehouse",
      },
      {
        title: "Pending Requests",
        path: "/buyerReqest/pending-request",
        icon: "warehouse",
      },
      {
        title: "Confirmed Requests",
        path: "/buyerReqest/confirmed-request",
        icon: "warehouse",
      },
      {
        title: "Inprogress Requests",
        path: "/buyerReqest/inprogress-request",
        icon: "warehouse",
      },
      {
        title: "Closed Requests",
        path: "/buyerReqest/closed-request",
        icon: "warehouse",
      },
    ],
  },
];
